import * as React from "react"
import { Route } from "react-router-dom"
import { PartyRole } from "@digits-graphql/frontend/graphql-bearer"
import useRouter from "@digits-shared/hooks/useRouter"
import { AnalysisChrome } from "src/frontend/components/OS/Applications/Analysis/AnalysisChrome"
import { RevenueOverview } from "src/frontend/components/OS/Applications/Analysis/Revenue/Overview/RevenueOverview"
import { RevenueHeader } from "src/frontend/components/OS/Applications/Analysis/Revenue/RevenueHeader"
import { TransactionBrowser } from "src/frontend/components/OS/Applications/Shared/Transactions/Browser/TransactionBrowser"
import { type DimensionCollectionRoutesNames } from "src/frontend/components/OS/Shared/Dimensions/DimensionCollectionRouteNames"
import { type PartiesCollectionRoutesNames } from "src/frontend/components/OS/Shared/Parties/PartiesCollectionDisplayToggle"
import routes from "src/frontend/routes"

const PartiesBreakdown = React.lazy(
  () => import("src/frontend/components/OS/Applications/Shared/Parties/PartiesBreakdown")
)

const TransactionsByCategory = React.lazy(
  () => import("src/frontend/components/OS/Applications/Shared/Categories/CategoriesBreakdown")
)

const CATEGORIES_COLLECTION_ROUTE_NAMES: DimensionCollectionRoutesNames = {
  list: routes.revenueByCategories.name,
  waterfall: routes.revenueByCategoriesWaterfall.name,
}

const CUSTOMERS_COLLECTION_ROUTE_NAMES: PartiesCollectionRoutesNames = {
  list: routes.revenueByCustomers.name,
  waterfall: routes.revenueByCustomersWaterfall.name,
}

/*
 COMPONENTS
*/

export const RevenueChrome: React.FC = () => (
  <AnalysisChrome Header={RevenueHeader} fallThrough={routes.revenue}>
    <Route exact path={routes.revenue.parameterizedPath} component={RevenueOverview} />

    <Route
      exact
      path={routes.revenueTransactions.parameterizedPath}
      component={RevenueTransactionBrowser}
    />
    <Route
      path={routes.revenueByCategories.parameterizedPath}
      component={RevenueCategoriesBreakdown}
    />

    <Route
      path={routes.revenueByCustomers.parameterizedPath}
      render={() => (
        <PartiesBreakdown
          title="Revenue by Customers"
          partyRole={PartyRole.EntityCustomerRole}
          routeNames={CUSTOMERS_COLLECTION_ROUTE_NAMES}
        />
      )}
    />
  </AnalysisChrome>
)

const RevenueTransactionBrowser: React.FC = () => {
  const { location } = useRouter()
  return <TransactionBrowser baseRoute={routes[location.name]} title="Revenue" />
}

const RevenueCategoriesBreakdown: React.FC = () => (
  <TransactionsByCategory
    title="Revenue by Category"
    routeNames={CATEGORIES_COLLECTION_ROUTE_NAMES}
  />
)
